export const SET_ERROR = 'SCHEDULED_BREAKS:SET_ERROR';
export const TOGGLE_LOADING = 'SCHEDULED_BREAKS:TOGGLE_LOADING';
export const TOGGLE_IS_REFETCH_NEEDED = 'SCHEDULED_BREAKS:TOGGLE_IS_REFETCH_NEEDED';
export const SET_SCHEDULED_BREAKS_DATA = 'SCHEDULED_BREAKS:SET_SCHEDULED_BREAKS_DATA';
export const TOGGLE_IS_ACTIONS_DISABLED = 'SCHEDULED_BREAKS:TOGGLE_IS_ACTIONS_DISABLED';
export const SET_DATE_PICKER_DATA = 'SCHEDULED_BREAKS:DATE_PICKER:SET_DATA';

export const setScheduledBreaksData = ({ scheduledBreaks, revision }) => ({
    type: SET_SCHEDULED_BREAKS_DATA,
    payload: { scheduledBreaks, revision }
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const setError = ({ error, isFetchError = false }) => ({
    type: SET_ERROR,
    payload: { error, isFetchError }
});

export const toggleIsRefetchNeeded = (isRefetchNeeded) => ({
    type: TOGGLE_IS_REFETCH_NEEDED,
    payload: isRefetchNeeded
});

export const toggleIsActionsDisabled = (isActionsDisabled) => ({
    type: TOGGLE_IS_ACTIONS_DISABLED,
    payload: isActionsDisabled
});

export const setData = (data) => ({
    type: SET_DATE_PICKER_DATA,
    payload: data
});
